import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrompt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-text-initial-icon lucide-text-initial",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M15 5h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 12h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 19h18" }),
		/* @__PURE__ */ _jsx("path", { d: "m3 12 3.553-7.724a.5.5 0 0 1 .894 0L11 12" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.92 10h6.16" })
	]
});
export default SvgPrompt;
